// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
  background: #ffffff;
  padding: 30px 16px 16px;
  text-align: center;
}
.wrapper .cross-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #000000;
  cursor: pointer;
  z-index: 10;
}
.wrapper .cross-icon ion-icon {
  font-size: 20px;
}
.wrapper .content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wrapper .content h3 {
  font-family: AppFontBlack, sans-serif;
  font-size: 28px;
  line-height: 130%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin-bottom: 18px;
}
.wrapper .content .subtitle {
  font-family: AppFontAlt;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0.01em;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 18px;
}
.wrapper .button-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}
.wrapper .button-wrapper .btn {
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  box-shadow: none;
  font-family: AppFontSemiBold, sans-serif;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.04em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
  cursor: pointer;
}
.wrapper .button-wrapper .login {
  background: var(--ion-color-primary);
}
.wrapper .button-wrapper .register {
  background: transparent;
  border: 1px solid var(--color-black);
  color: var(--color-black);
}
.wrapper .button-wrapper .guest {
  background: transparent;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/components/ask-to-create-account-modal/ask-to-create-account-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACD;AACC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AACF;AACE;EACC,eAAA;AACH;AAGC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAGE;EACC,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AADH;AAIE;EACC,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,mBAAA;AAHH;AAOC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AALF;AAOE;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,eAAA;AAPH;AAUE;EACC,oCAAA;AARH;AAWE;EACC,uBAAA;EACA,oCAAA;EACA,yBAAA;AATH;AAYE;EACC,uBAAA;EAEA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;AAXH","sourcesContent":[".wrapper {\n\tposition: relative;\n\tbackground: #ffffff;\n\tpadding: 30px 16px 16px;\n\ttext-align: center;\n\n\t.cross-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 50%;\n\t\tcolor: #000000;\n\t\tcursor: pointer;\n\t\tz-index: 10;\n\n\t\tion-icon {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\n\t.content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\th3 {\n\t\t\tfont-family: AppFontBlack, sans-serif;\n\t\t\tfont-size: 28px;\n\t\t\tline-height: 130%;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 18px;\n\t\t}\n\n\t\t.subtitle {\n\t\t\tfont-family: AppFontAlt;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.01em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\n\t\t\tmargin-bottom: 18px;\n\t\t}\n\t}\n\n\t.button-wrapper {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 15px;\n\t\talign-items: center;\n\n\t\t.btn {\n\t\t\twidth: 100%;\n\t\t\theight: 48px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tborder-radius: 25px;\n\t\t\tbox-shadow: none;\n\n\t\t\tfont-family: AppFontSemiBold, sans-serif;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.04em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--color-white);\n\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t.login {\n\t\t\tbackground: var(--ion-color-primary);\n\t\t}\n\n\t\t.register {\n\t\t\tbackground: transparent;\n\t\t\tborder: 1px solid var(--color-black);\n\t\t\tcolor: var(--color-black);\n\t\t}\n\n\t\t.guest {\n\t\t\tbackground: transparent;\n\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\ttext-decoration: underline;\n\t\t\ttext-decoration-style: solid;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
